import { DateTime } from "luxon";
import { Task, ScheduledTask } from "./Task";

export enum TaskFilter {
  LAST_WEEK = "LAST_WEEK",
  LAST_FOUR_WEEKS = "LAST_FOUR_WEEKS",
  STARTING_FROM_TODAY = "STARTING_FROM_TODAY",
  ALL = "ALL",
}

function getCutOffTimestampForTaskFilter(taskFilter: TaskFilter) {
  if (taskFilter === TaskFilter.ALL) {
    return Number.MIN_SAFE_INTEGER;
  }

  const now = DateTime.fromJSDate(new Date());

  return now
    .startOf("week")
    .minus({ week: taskFilter === TaskFilter.LAST_WEEK ? 1 : 4 })
    .valueOf();
}

function getCutOffTimestampForConfirmedTaskFilter(
  confirmedTaskFilter: TaskFilter
) {
  if (confirmedTaskFilter === TaskFilter.ALL) {
    return Number.MIN_SAFE_INTEGER;
  }

  const now = DateTime.fromJSDate(new Date());

  return (confirmedTaskFilter == TaskFilter.STARTING_FROM_TODAY
    ? now.startOf("day")
    : now.startOf("day").minus({ day: 6 })
  ).valueOf();
}

export function applyTaskFilter(tasks: Task[], taskFilter: TaskFilter): Task[] {
  if (taskFilter == TaskFilter.ALL) {
    return tasks;
  }

  const cutOffTimestamp = getCutOffTimestampForTaskFilter(taskFilter);

  return tasks.filter(
    (task) => task.earliestStartDate.getTime() >= cutOffTimestamp
  );
}

export function applyScheduledTaskFilter(
  scheduledTasks: ScheduledTask[],
  confirmedTaskFilter: TaskFilter,
  taskFilter: TaskFilter
): ScheduledTask[] {
  if (confirmedTaskFilter == TaskFilter.ALL) {
    return scheduledTasks;
  }

  const cutOffTimestampConfirmed = getCutOffTimestampForConfirmedTaskFilter(
    confirmedTaskFilter
  );

  const cutOffTimestampUnconfirmed = getCutOffTimestampForTaskFilter(
    taskFilter
  );

  return scheduledTasks.filter((scheduledTask) =>
    scheduledTask.wasConfirmed
      ? scheduledTask.startDate.getTime() >= cutOffTimestampConfirmed
      : scheduledTask.earliestStartDate.getTime() >= cutOffTimestampUnconfirmed
  );
}
